/**
 * The typed refusals a GNey turn can meet, turned into the card the chat shows instead of an
 * error bubble - each is an expected state with a next step, not a failure:
 *
 *   402 credits_exhausted        the workspace's AI credits are used up (the credit gate)
 *   402 ai_not_included          seats (P3.5); kept for the day it arrives
 *   403 ai_disabled_for_member   a workspace admin switched GNey off for this person (pricing
 *                                spec §11 R3) - a 403, because topping up would not change it
 *
 * Kept out of FTSClientTeammate so the rule can be tested without mounting the whole chat.
 */
export const GNEY_SWITCHED_OFF = "ai_disabled_for_member";

/** The block a failed turn carries, or null for any other failure (which stays an error). */
export function blockFromError(err) {
  const r = err && err.response;
  if (!r || !r.data || !r.data.code) return null;
  // AutoCount Full's 402 (connectorLock.js) is about a module, not AI credits: it stays an error here.
  if (r.data.code === "connector_full_required") return null;
  const switchedOff = r.status === 403 && r.data.code === GNEY_SWITCHED_OFF;
  if (r.status !== 402 && !switchedOff) return null;
  return { code: r.data.code, isWorkspaceAdmin: !!r.data.isWorkspaceAdmin };
}

export function blockTitle(block) {
  if (block && block.code === GNEY_SWITCHED_OFF) return "GNey is switched off for you";
  return block && block.code === "ai_not_included" ? "GNey needs a seat" : "AI credits used up";
}

export function blockText(block) {
  if (block && block.code === GNEY_SWITCHED_OFF) {
    // One text for everyone: whether the person is an admin here is not something the refusal
    // can tell reliably, and an admin reading it knows they can act on it.
    return "A workspace admin has switched GNey off for you in this workspace, so nothing here spends AI credits in your name. A workspace admin can switch it back on in the people list.";
  }
  if (block && block.code === "ai_not_included") {
    return block.isWorkspaceAdmin
      ? "GNey isn't enabled for this member — turn it on in workspace member settings."
      : "GNey isn't included for your seat yet — ask a workspace admin for access.";
  }
  return block && block.isWorkspaceAdmin
    ? "This workspace's AI credits are used up. Top up in Plan & Credits (workspace settings) to keep going."
    : "This workspace's AI credits are used up — ask a workspace admin to top up.";
}

export default { GNEY_SWITCHED_OFF, blockFromError, blockTitle, blockText };
